export default class ProjectGrid {
	constructor() {
		this.projectGrids = document.querySelectorAll('[data-project-grid]')

		if (!this.projectGrids.length) return

		this.abortController = new AbortController()
		this.observers = []
		this.clonedVideos = []
		this.bgVideos = new Map()
		this.activeProject = null

		this.#init()
	}

	#init() {
		this.projectGrids.forEach(container => this.#handleProjectGrid(container))
	}

	#handleProjectGrid(container) {
		const bgContainer = container.querySelector('[data-project-grid-bg]')
		const bgVideo = bgContainer?.querySelector('video')

		if (!bgVideo) return

		const projects = container.querySelectorAll('.tease-project')

		if (!projects.length) return

		this.#lazyLoadVideos(projects)
		this.#preloadBackgroundVideos(projects, bgVideo)

		projects.forEach(project => this.#handleHover(project))
	}

	#lazyLoadVideos(projects) {
		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					const video = entry.target.querySelector('video')
					if (!video) return

					if (!entry.isIntersecting) {
						video.pause()
						return
					}

					if (!video.src && video.dataset.src) {
						video.src = video.dataset.src
						video.load()
					}

					video.play()
				})
			},
			{ threshold: 0.25 }
		)

		projects.forEach(project => observer.observe(project))
		this.observers.push(observer)
	}

	#preloadBackgroundVideos(projects, bgVideo) {
		projects.forEach(project => {
			const projectVideo = project.querySelector('video')
			const url = projectVideo?.dataset.src

			if (!url || this.bgVideos.has(url)) return

			const preloaded = bgVideo.cloneNode()
			preloaded.src = url
			preloaded.preload = 'auto'
			preloaded.classList.add('opacity-0')
			bgVideo.parentElement.appendChild(preloaded)
			preloaded.play()

			this.bgVideos.set(url, { el: preloaded, projectVideo })
			this.clonedVideos.push(preloaded)
		})
	}

	#handleHover(project) {
		const { signal } = this.abortController

		project.addEventListener(
			'mouseenter',
			() => {
				const projectVideo = project.querySelector('video')
				const url = projectVideo?.dataset.src || projectVideo?.src

				if (!url) return

				this.activeProject = project
				const entry = this.bgVideos.get(url)
				if (!entry) return

				this.bgVideos.forEach(({ el }) => {
					if (el !== entry.el) {
						el.classList.remove('opacity-100')
						el.classList.add('opacity-0')
					}
				})

				entry.el.classList.remove('opacity-0')
				entry.el.classList.add('opacity-100')
			},
			{ signal }
		)

		project.addEventListener(
			'mouseleave',
			() => {
				if (this.activeProject === project) this.activeProject = null

				this.bgVideos.forEach(({ el }) => {
					el.classList.remove('opacity-100')
					el.classList.add('opacity-0')
				})
			},
			{ signal }
		)
	}

	destroy() {
		this.abortController?.abort()
		this.observers.forEach(observer => observer.disconnect())
		this.clonedVideos.forEach(video => {
			video.pause()
			video.removeAttribute('src')
			video.load()
			video.remove()
		})
		this.observers = []
		this.clonedVideos = []
		this.bgVideos.clear()
		this.activeProject = null
	}
}
